

import React, { useContext, useEffect, useState } from 'react'
import Navbar1 from '../../components/mynavbar/navbar1.components'
import HomeHeader from './homeheader.components'
import CategoryItem from './category-item.components'
import PreorderForm from '../../components/forms/preorder.components'
// import cupcake from '../../assets/images/cupcakes.png'
// import wedcake from '../../assets/images/wedding-cakes.png'
import ContactForm from '../../components/contact/contactform.components'
import { OrderContext } from '../../context/order.context'
import ServiceItems from './service-items.components'
import Except1 from './page-except1.components'
import './homepage.styles.scss'
import { useLocation } from 'react-router-dom'
import PsBanner from './psbanner.components'

const HomePage = () => {

  const callouts = [
    {
      name: 'Category One',
      description: 'Short description from category one',
      imageSrc: 'https://i.pinimg.com/564x/16/fb/99/16fb9968fcc654addbc7a21ade300d3a.jpg',
      imageAlt: 'Short description from category one.',
      href: '#',
    },
    {
      name: 'Category Two',
      description: 'Short description from category two',
    //   imageSrc: 'https://i.pinimg.com/564x/39/da/62/39da62db39bd043917500362e60c6255.jpg',
      imageSrc: 'https://i.pinimg.com/564x/6b/3a/6e/6b3a6e4dc26aca5a3df6247b07d78d24.jpg',
      imageAlt: 'Short description from category two.',
      href: '#',
    },
    {
      name: 'Category Three',
      description: 'Short description from category three',
      imageSrc: 'https://i.pinimg.com/564x/5e/21/94/5e2194154e9a83fff4cca190085f8984.jpg',
      imageAlt: 'Short description from category three.',
      href: '#',
    },
  ]

  const defaultCompanyValues = {
    companyDisplayName: '',
    companyName: '',
    slogan: '',
    address1: '',
    address2: '',
    phone: '',
    email: '',
    country: '',
    ig: '',
    fb: '',
    tw: '',
    tq: '',
    yt: '',
    logo: 'No file uploaded',
    createdAt: new Date()
  }


  const defaultValues = {
    title: 'Bridging Languages and Cultures',
    subtitle1: "Professional Translation, Interpretation and Legal Assistance.",
    subtitle2: "",
    cat1: 'Category One',
    cat1_desc: 'Short description from category one',
    cat2: 'Category Two',
    cat2_desc: 'Short description from category two',
    cat3: 'Category Three',
    cat3_desc: 'Short description from category three',
    about_img_url: 'https://img.freepik.com/premium-photo/portrait-smiling-female-baker-leaning-stack-bread_604472-24133.jpg',
    about_name: 'Patric Ola Yawson',
    about_title: 'Our Chief',
    about_text: "Discover the range of delights that Sandy's Cake offers. From decadent cakes to mouthwatering pastries, our creations are crafted with passion and precision. Whether for a special celebration or a sweet craving, Discover the range of delights that Sandy's Cake offers. From decadent cakes to mouthwatering pastries, our creations are crafted with passion and precision. Whether for a special celebration or a sweet craving, we have the perfect treat to make your day extraordinary. Explore our menu, book your custom order, and enjoy the finest baked goods made with love and the best ingredients.",
    more_sandy: "Discover the range of delights that Sandy's Cake offers. From decadent cakes to mouthwatering pastries, our creations are crafted with passion and precision. Whether for a special celebration or a sweet craving, we have the perfect treat to make your day extraordinary. Explore our menu, book your custom order, and enjoy the finest baked goods made with love and the best ingredients.",
    company: [],
    del: 'no',
    created_at: new Date(),
    updated_at: null,
  }
  
  const { curPage } = useContext(OrderContext)
  const [ newCurPage, setNewCurPagae ] = useState(defaultValues)
  const { title, subtitle1, subtitle2, cat1, cat1_desc, cat2, cat2_desc, cat3, cat3_desc, about_img_url, about_name, about_title, about_text, more_sandy, created_at, del } = newCurPage
//   console.log('cur: ', newCurPage)


const location = useLocation();

useEffect(() => {
  // Check if there's a hash or state specifying where to scroll
  const hash = location.hash;
  if (hash) {
    const element = document.querySelector(hash);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }
}, [location]);


  useEffect(() => {
    if (curPage) {
        setNewCurPagae(curPage)
    }
  }, [curPage])

  return (
    <>
    <div className="header">
      <HomeHeader pageDet={newCurPage} />
    </div>

    <PsBanner />

    <div className="bg-gray-100 cake-categories">
        {/* <h2>Our Categories</h2> */}

        <div className=""> 
            <div className="general-container bg-gray-100">
                <div className="mx-auto max-w-2xl py-16 sm:py-24 lg:max-w-none lg:py-32">
                    <h2 className="pannel-header">Our Services</h2>
                    <h4 className='mb-6 text-center uppercase text-xs tracking-widest text-violet-950'>Get a Free Consultation</h4>

                    <div className="space-y-6 sm:space-y-12 lg:grid lg:grid-cols-3 lg:gap-x-6 lg:space-y-0">
                        <ServiceItems pageContent={newCurPage} />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Except1 />


    <ContactForm company={newCurPage.company} />
    
    </>
  )
}

export default HomePage